<nav class="valg-paginator__container">
  <div class="valg-paginator__page-size-container relative-sm" *ngIf="showPageSizeMenu">
    <button class="valgButton valg-paginator__page-size-button" mat-button
            [matMenuTriggerFor]="pageSizeMenu"
            [matMenuTriggerData]="{pageSizes: paginationSteps}"
            disableRipple>
      <div class="valg-paginator__page-size-button__text">
        <span class="h4">{{SELECT_PAGE_SIZE_TEXT | translate : {value: pageSize} }} </span>
        <mat-icon class="valg-paginator__page-size-button__icon" [svgIcon]="SvgIcon.DropdownArrow"></mat-icon>
      </div>
    </button>
  </div>
  <div class="valg-paginator__page-select-container" *ngIf="shouldShowPagination()" role="tablist" [attr.aria-setsize]="availablePages-1">
    <button
            valgButton
            color="icon"
            class="valg-button valg-button__paginator pagination-button__arrow"
            attr.aria-label="{{'table.previous_page' | translate}}"
            (click)="onNavigationChange(currentPage-1)"
            [disabled]="currentPage === 1">
      <mat-icon class="pagination-button__icon" [class.d-none]="currentPage === 1" [svgIcon]="SvgIcon.ChevronLeft"></mat-icon>
    </button>
    <button
            valgButton
            color="icon"
            class="valg-button valg-button__paginator pagination-button__index"
            [class.selected]="value === currentPage" *ngFor="let value of getFirstPagesArray()"
            attr.aria-label="{{'table.page' | translate}} {{value}}"
            [attr.aria-pressed]="value === currentPage"
            role="tab"
            [attr.aria-selected]="value === currentPage"
            [attr.aria-posinset]="value"
            (click)="onNavigationChange(value)">
      {{value}}
    </button>
    <div
            *ngIf="showFirstEllipsis">
      <mat-icon class="pagination-ellipsis__icon" [svgIcon]="SvgIcon.PaginationEllipsis"></mat-icon>
    </div>
    <button
            valgButton
            color="icon"
            class="valg-button valg-button__paginator pagination-button__index"
            [class.selected]="value === currentPage" *ngFor="let value of getMiddlePagesArray()"
            attr.aria-label="{{'table.page' | translate}} {{value}}"
            [attr.aria-pressed]="value === currentPage"
            role="tab"
            [attr.aria-selected]="value === currentPage"
            [attr.aria-posinset]="value"
            (click)="onNavigationChange(value)">
      {{value}}
    </button>
    <div
            *ngIf="showSecondEllipsis">
      <mat-icon class="pagination-ellipsis__icon" [svgIcon]="SvgIcon.PaginationEllipsis"></mat-icon>
    </div>
    <button
            valgButton
            color="icon"
            class="valg-button valg-button__paginator pagination-button__index"
            [class.selected]="value === currentPage" *ngFor="let value of getLastPagesArray()"
            attr.aria-label="{{'table.page' | translate}} {{value}}"
            [attr.aria-pressed]="value === currentPage ? 'true' : 'false'"
            role="tab"
            [attr.aria-selected]="value === currentPage"
            [attr.aria-posinset]="value"
            (click)="onNavigationChange(value)">
      {{value}}
    </button>
    <button
            valgButton
            color="icon"
            class="valg-button valg-button__paginator pagination-button__arrow"
            attr.aria-label="{{'table.next_page' | translate}}"
            (click)="onNavigationChange(currentPage+1)"
            [disabled]="currentPage === availablePages">
      <mat-icon class="valg-button__paginator pagination-button__icon" [class.d-none]="currentPage === availablePages" [svgIcon]="SvgIcon.ChevronRight"></mat-icon>
    </button>
  </div>
</nav>
<mat-menu #pageSizeMenu="matMenu" >
  <ng-template matMenuContent let-pageSizes="pageSizes">
    <button mat-menu-item *ngFor="let page of pageSizes" (click)="pageSize = page">{{page}}</button>
  </ng-template>
</mat-menu>
